export enum Tab {
  DEPOSIT,
  LOCK,
  WITHDRAW,
  REWARDS,
}
